/*
BACKEND.API.TS
Fetch IDTree backend
*/

import { instanceBackend } from "@/App"
import i18n from "@/translate/i18n"
import { snakeCase } from "lodash"
import { toast } from "react-toastify"
import { store } from "../root-reducer"
import { sessionShowError } from "@/redux/_session.actions"
import { Method } from "axios"
import { processError } from "@/utils/api-get-error.utils"

type FetchBackendOptions = {
  url: string
  method?: Method
  data?: any
  timeout?: number
}

type FetchBackendResponse = any | { error: string }

//Envoyer données au backend
export async function fetchBackend(options: FetchBackendOptions): Promise<FetchBackendResponse> {
  //Detect how to form param (if GET or DELETE )
  const method = options.method ? options.method : "GET"
  const dataOrParams = ["GET", "DELETE"].indexOf(method) > -1 ? "params" : "data"

  return instanceBackend
    .request({
      url: options.url,
      method,
      [dataOrParams]: options.data,
      ...(options.timeout ? { timeout: options.timeout } : {})
    })
    .then(({ data }) => {
      if (data.error) {
        //IF errors array (sequelize)
        if (data.error.errors) {
          toast(i18n.t(snakeCase(data.error.errors[0].message)), {
            type: "error"
          })
        } else {
          toast(i18n.t(data.error), { type: "error" })
        }
      }

      return data
    })
    .catch((error) => {
      if (error.response) {
        const code: string = processError(error.response)
        toast(i18n.t(code) + (error.response.data.details ? " " + error.response.data.details : ""), { type: "error" })
        return { error: code }
      } else {
        store.dispatch(sessionShowError(i18n.t("middleware_error_timeout"), error.toString()))
        return { error: "network error", details: error }
      }
    })
}
